import type { IApplicationState } from 'shared/types/redux';

export const selectCPDChatIdLoadingStatus = (state: IApplicationState) => state.cpd.cpdChatIdLoadingStatus;
